import { render, staticRenderFns } from "./TaskDetail.vue?vue&type=template&id=00491d2e&scoped=true"
import script from "./TaskDetail.vue?vue&type=script&lang=js"
export * from "./TaskDetail.vue?vue&type=script&lang=js"
import style0 from "./TaskDetail.vue?vue&type=style&index=0&id=00491d2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00491d2e",
  null
  
)

export default component.exports